export const CALL_TYPES = {
  INCOMING: "incoming",
  OUTGOING: "outgoing",
};
